<cx-accordion [title]="'Descrição'" [icon]="'description'" [isActive]="true">
  {{ product.description }}
</cx-accordion>
